import {useCAPIQuery} from '@github-ui/copilot-shared-ui/capi/use-capi-query'
import {fetchCAPI} from '@github-ui/copilot-shared-ui/capi/fetch-capi'
import type {AutomationDetail} from '../types/automations-payload'

export const automationQueryKey = (owner: string, repo: string, automationId?: string) => [
  'automation',
  owner,
  repo,
  automationId,
]

export async function fetchAutomation(owner: string, repo: string, automationId: string): Promise<AutomationDetail> {
  const response = await fetchCAPI({path: `/agents/repos/${owner}/${repo}/automations/${automationId}`})
  const data: AutomationDetail = await response.json()
  return data
}

export function useAutomation({
  owner,
  repo,
  automationId,
  initialData,
  retry,
}: {
  owner: string
  repo: string
  automationId?: string
  initialData?: AutomationDetail
  retry?: boolean
}) {
  const {data, isLoading, isError} = useCAPIQuery<AutomationDetail>({
    queryKey: automationQueryKey(owner, repo, automationId),
    queryFn: () => {
      if (!automationId) {
        throw new Error('automationId is required')
      }
      return fetchAutomation(owner, repo, automationId)
    },
    initialData,
    enabled: !!automationId,
    ...(retry === undefined ? {} : {retry}),
  })

  return {
    automation: data,
    isLoading,
    isError,
  }
}
